import AuthLayout from '../Layouts/AuthLayout';

import FormCompleteRegister from '../Components/FormCompleteRegister';

function App() {
    return (
        <AuthLayout>
            <div className="mx-auto w-full max-w-3xl">
                <div className="">
                    <div className="mx-auto mb-8 lg:mb-12 flex flex-col">
                        <img src={`/assets/img/rometal-logo.png`} alt="logo" className="block w-1/2 max-w-[300px] mx-auto" />
                    </div>

                    <FormCompleteRegister />
                </div>
            </div>
        </AuthLayout>
    );
}

export default App;
